/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import PropTypes from 'prop-types';

import { FlexItem } from '@ba-ui-toolkit/flexlayout';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import SVGIcon from '@ba-ui-toolkit/svgicon';
import TruncatedText from '@ba-ui-toolkit/truncatedtext';

import ListItem from '../ListItem';
import menuStyles from '../List.scss';

const MenuClassName = menuStyles.menuClassName.replace(/"/g, '');

const { sanitize } = propsUtils;

function createIcon(className, iconId) {
	return <SVGIcon className={cx(`${className}__icon`)} iconId={iconId} size="small" />;
}

export const DefaultItemRenderer = props => {
	const { itemProps, itemSpec } = props;
	const { label, disabled, icon: _leftIcon, rightIcon: _rightIcon, ...others } = itemSpec;

	const leftIcon = _leftIcon ? createIcon(MenuClassName, _leftIcon.id) : null;
	const rightIcon = _rightIcon ? createIcon(MenuClassName, _rightIcon.id) : null;

	const listItemProps = {
		disabled,
		className: cx(`${MenuClassName}__item`),
		...itemProps,
		...sanitize(others, null, 'id', 'value'),
	};

	const flexItemProps = {
		grow: true,
		basis: 'auto',
		className: cx(`${MenuClassName}__item--text`),
	};

	const textProps = {
		className: 'cursor',
		value: label,
		location: 'middle',
	};

	return (
		<ListItem {...listItemProps}>
			{leftIcon}
			<FlexItem {...flexItemProps}>
				<TruncatedText {...textProps} />
			</FlexItem>
			{rightIcon}
		</ListItem>
	);
};

DefaultItemRenderer.propTypes = {
	itemSpec: PropTypes.object,
	itemProps: PropTypes.object,
};
